import {
    Checkbox,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    SelectChangeEvent,
    useTheme,
} from '@mui/material'
import React from 'react'
import { PaymentState } from '../../services/api/sharedTypes/Common'
import { convertPaymentStateTypeToString, convertStringToPaymentState } from '../../utils/event-utils'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'

interface PaymentStateFilterProps {
    paymentState: PaymentState[]
    onChange: (paymentState: PaymentState[]) => void
}

const PaymentStateFilter: React.FC<PaymentStateFilterProps> = ({ paymentState, onChange }: PaymentStateFilterProps) => {
    const theme = useTheme()

    const handlePaymentSelectChange = (event: SelectChangeEvent<PaymentState[]>) => {
        const {
            target: { value },
        } = event
        typeof value === 'string' ? onChange(value.split(',').map(Number)) : onChange(value)
    }

    return (
        <FormControl size='small' fullWidth style={{ maxWidth: 162, minWidth: 100, marginTop: theme.spacing(2) }}>
            <InputLabel>Stav platby</InputLabel>
            <Select
                multiple
                value={paymentState}
                onChange={handlePaymentSelectChange}
                input={<OutlinedInput label='Stav platby' style={{ maxHeight: 36 }} />}
                renderValue={(selected) =>
                    selected
                        .map((paymentState) => convertPaymentStateTypeToString(convertStringToPaymentState(Number(paymentState))))
                        .join(', ')
                }
            >
                <MenuItem value={PaymentState.NotSet} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={paymentState.indexOf(PaymentState.NotSet) > -1} />
                    {convertPaymentStateTypeToString(PaymentState.NotSet)}
                </MenuItem>
                <MenuItem value={PaymentState.Paid} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={paymentState.indexOf(PaymentState.Paid) > -1} />
                    {convertPaymentStateTypeToString(PaymentState.Paid)}
                </MenuItem>
                <MenuItem value={PaymentState.NotPaid} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={paymentState.indexOf(PaymentState.NotPaid) > -1} />
                    {convertPaymentStateTypeToString(PaymentState.NotPaid)}
                </MenuItem>
                <MenuItem value={PaymentState.Free} style={{ maxHeight: '36px' }}>
                    <Checkbox checked={paymentState.indexOf(PaymentState.Free) > -1} />
                    {convertPaymentStateTypeToString(PaymentState.Free)}
                </MenuItem>
                <MenuItem style={{ borderTop: '1px solid gray' }}>
                    <RefreshRoundedIcon style={{ marginLeft: theme.spacing(2), marginRight: theme.spacing(2) }} />

                    <ListItemText primary='Zrušit filtr' onClick={() => onChange([])} />
                </MenuItem>
            </Select>
        </FormControl>
    )
}

export default PaymentStateFilter
